<template>
  <div>
    <data-table :data="data"
                :title="title"
                :entity="'product'"
                :columns="columns"
                :disable-permission-checks="true"
                :go-to-details-on-row-click="false"
                :go-to-add-on-click="false"
                :show-confirm-before-delete="false"
                :clickable="false"
                :show-pagination="false"
                :searchable="false"
                operations=""
    >
      <template v-slot:price="{row}">
        {{row.price | toCurrency}}
      </template>

      <template v-slot:extra-buttons="{row}">
        <base-button class="btn-sm" outline @click="onOrderClick(row)">{{$t('generic.buyNow')}}
        </base-button>
      </template>
    </data-table>
  </div>
</template>

<script>
  import * as icons from 'vue-feather-icons'

  export default {
    name: 'product-table',
    components: {
      ...icons,
    },
    props: {
      title: String,
      productType: String,
      data: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      columns () {
        return [
          {
            prop: 'name',
            label: this.$t('settings.products.labels.name'),
            minWidth: '200px'
          }, {
            prop: 'price',
            label: this.$t('settings.products.labels.price'),
            minWidth: '100px',
          },
        ]
      }
    },
    methods: {
      onOrderClick (row) {
        this.$emit('click-order', this.productType, row.id)
      },
    }
  }
</script>
